import React, { useCallback } from 'react';

import { useField } from 'formik';

import { Switch, SwitchProps } from './Switch';

export type FormikSwitchProps = Pick<
  SwitchProps,
  'label' | 'hint' | 'id' | 'name' | 'disabled'
>;

export const FormikSwitch: React.FunctionComponent<FormikSwitchProps> = props => {
  const [field, , { setValue }] = useField<boolean>(props.name);

  const onChange = useCallback(
    (_, newChecked) => {
      setValue(newChecked);
    },
    [setValue],
  );

  return (
    <Switch
      {...props}
      name={field.name}
      checked={field.value}
      onChange={onChange}
    />
  );
};
